import React, { useState, useRef, useEffect, useField, Field } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import SmartGoalimg from "../Forms/smart-business-goals1.png";
import Select from "react-select";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function SuperAdminPassword() {
  const selectInputRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);

  const [employeesData, setEmployeesData] = useState([]);
  const [employeeinitalsdata, setEmployeesInitialData] = useState([]);

  const [modifiedAssignees, setModifiedAssignees] = useState("");

  const [isdeptselected, setIsDeptselected] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [allEmployee, setAllEmployees] = useState(null);

  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const handleRemoveAllOptions = () => {
    setAllEmployees([]);
  };

  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getallassigneesb`
        );
        setAllEmployees(response.data.employees);
        setEmployeesInitialData(response.data.employees);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
  }, []);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);

      const response = await axios.post(
        `${baseURL}/superadminchangepassword`,
        formData
      );

      if (response.status === 200) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
          navigate("/userTable");
        }, 3000);

        // Redirect to the desired page
        // window.location.href = "/goals"; // Update "/goals" with the desired URL
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  function getLastDayOfYear(date) {
    const year = date.getFullYear();
    // const lastDay = new Date(year, 12, 31);
    let lastDay = new Date();
    lastDay.setFullYear(year);
    lastDay.setMonth(11, 31); // December is 11 in JavaScript
    return lastDay.toISOString().substr(0, 10);
  }

  return (
    <>
      <Formik
        initialValues={{
          newpassword: "",
          assignee: "",
        }}
        validationSchema={Yup.object({
          assignee: Yup.string().required("User is required"),
          newpassword: Yup.string().required("New password is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
        }) => (
          <div className="container">
            {/* <h4 className="text-start  pb-2">ADD KPI</h4> */}
            <div className="col-lg-12  mt-1 m-5">
              <h5>Reset Password</h5>
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5 mt-2">
                    <label>
                      Select User <span className="text-danger">*</span>
                    </label>
                    <Select
                      ref={selectInputRef}
                      isMulti={false}
                      name="assignee"
                      options={employeeinitalsdata.map((employee) => ({
                        value: employee.employeeid,
                        label: `${employee.FirstName} ${
                          employee.LastName !== null ? employee.LastName : ""
                        } - ${employee.employeeid}`,
                      }))}
                      onChange={(selectedOptions) => {
                        setSelectedUser(selectedOptions);
                        setFieldValue("assignee", selectedOptions.value);
                      }}
                    />

                    {touched.assignees && errors.assignees ? (
                      <div className="text-danger">{errors.assignees}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-2">
                    <label>New Password</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      name="newpassword"
                      onChange={(e) => {
                        const value = Math.min(parseInt(e.target.value), 100);
                        setFieldValue("newpassword", e.target.value);
                      }}
                      value={values.newpassword}
                    />
                    {touched.newpassword && errors.newpassword ? (
                      <div className="text-danger">{errors.newpassword}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/goals">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default SuperAdminPassword;
